import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { Link } from 'react-router-dom';
import FAQAccordion from '../components/faq/FAQAccordion';
import { useT } from '../i18n/useT';
import { useLanguage } from '../i18n/LanguageContext';
import './FAQPage.css';

export default function FAQPage() {
  const t = useT();
  const { lang } = useLanguage();
  const p = t.pages.faq;
  const fq = t.faqPreview;
  const faqs = t.faqs;

  // Derive unique categories from the translated FAQ list
  const allLabel = lang === 'de' ? 'Alle' : 'All';
  const categories = [allLabel, ...Array.from(new Set(faqs.map(f => f.category)))];
  const [activeCategory, setActiveCategory] = useState(allLabel);

  // Reset to "All/Alle" when language switches
  useEffect(() => {
    setActiveCategory(allLabel);
  }, [lang]); // eslint-disable-line react-hooks/exhaustive-deps

  const filtered = activeCategory === allLabel
    ? faqs
    : faqs.filter(f => f.category === activeCategory);

  return (
    <>
      <Helmet>
        <title>{p.title} – Docudi</title>
        <meta name="description" content={p.sub} />
        <link rel="canonical" href="https://[YOUR-DOMAIN.com]/faq" />
      </Helmet>

      <section className="page-hero">
        <div className="container">
          <div className="page-hero__content text-center">
            <div className="badge badge-gray">{p.title}</div>
            <h1 className="page-hero__title">{p.headline}</h1>
            <p className="page-hero__sub">
              {fq.sub}{' '}
              <Link to="/contact" style={{ color: 'var(--color-primary)', fontWeight: '600' }}>
                {fq.contact}
              </Link>
            </p>
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-narrow">
          <div className="faq-page__cats" role="group" aria-label="Filter by category">
            {categories.map(cat => (
              <button
                key={cat}
                className={`faq-page__cat-btn ${activeCategory === cat ? 'is-active' : ''}`}
                onClick={() => setActiveCategory(cat)}
                aria-pressed={activeCategory === cat}
              >
                {cat}
              </button>
            ))}
          </div>

          <FAQAccordion items={filtered} />

          <div className="faq-page__contact">
            <h3>{fq.headline}</h3>
            <p>{fq.sub}</p>
            <Link to="/contact" className="btn btn-primary">{fq.contact}</Link>
          </div>
        </div>
      </section>
    </>
  );
}
